class VimeoPlayerManager {

    static vimeoPlayer() {
        const iframe = document.querySelector('iframe');
        if (!iframe || !iframe.src.includes('player.vimeo.com')) return;

        const player = new Vimeo.Player(iframe);

        function savePlaybackRateToCache(rate) {
            localStorage.setItem('vimeoPlaybackRate', rate);
        }

        function setPlaybackRateFromCache() {
            let savedPlaybackRate = parseFloat(localStorage.getItem('vimeoPlaybackRate')) || 1.0;

            if (savedPlaybackRate < 0.5 || savedPlaybackRate > 2) savedPlaybackRate = 1.0;

            player.ready().then(() => {
                player.setPlaybackRate(savedPlaybackRate).catch((error) => {
                    console.warn('Could not set playback rate (maybe not supported):', error);
                });
            });
        }

        function setVideoProgressFromCache() {
            if (iframe && iframe.dataset.vimeoPlaybackProgress) {
                const savedProgress = parseInt(iframe.dataset.vimeoPlaybackProgress);
                if (savedProgress) {
                    player.setCurrentTime(parseFloat(savedProgress)).catch(error => {
                        console.error('Error setting video time:', error);
                    });
                }
            }
        }

        function saveVideoProgress(seconds) {
            const progressUpdateUrl = iframe.dataset.progressUpdateUrl;
            $.ajax({
                url: progressUpdateUrl,
                method: 'PATCH',
                contentType: 'application/json',
                data: JSON.stringify({ progress: seconds }),
                error: function (xhr, status, error) {
                  console.error('Failed to save video progress', error);
                }
            });
        }

        setPlaybackRateFromCache();
        setVideoProgressFromCache();

        player.on('playbackratechange', (event) => {
            savePlaybackRateToCache(event.playbackRate);
        });

        player.on('timeupdate', event => {
            saveVideoProgress(event.seconds);
        });
    }
}

export default VimeoPlayerManager;